import React, { useEffect, useState } from 'react';

declare global {
  interface Window {
    IMP?: any;
  }
}

const DanalTestPage = () => {
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');

  const handleCertify = () => {
    const IMP = window.IMP;
    if (!IMP) return alert('포트원 모듈이 로드되지 않았습니다.');

    IMP.init('imp28577706'); // ✅ 포트원 가맹점 식별코드

    IMP.certification(
      {
        pg: 'danal',
        merchant_uid: `cert_${Date.now()}`,
        company: '다원트레이드',
        customer: {
          phoneNumber: '01012345678',
          fullName: '홍길동',
        },
        bypass: {
          danal: {
            IsCarrier: 'SKT;KTF;LGT',
            AGELIMIT: 19,
            CPTITLE: 'event.dwt.kr',
          },
        },
      },
      async (rsp: any) => {
        if (rsp.success && rsp.imp_uid) {
          try {
            const res = await fetch('https://api-4iuywcitfq-uc.a.run.app/api/verify-identity', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ imp_uid: rsp.imp_uid }),
            });
            const data = await res.json();

            console.log('🔍 응답 데이터 확인:', data);

            if (res.ok && data) {
              setName(data.name || '');
              setPhone(data.phone || ''); // 📌 phone은 응답에 없을 수 있으므로 빈값 허용
            } else {
              alert(`서버 오류: ${data?.error || '응답 포맷 오류'}`);
            }
          } catch (error) {
            console.error('❌ 인증 정보 요청 실패:', error);
            alert('서버 통신 오류로 인증 정보를 불러올 수 없습니다.');
          }
        } else {
          alert(`인증 실패: ${rsp.error_msg || '알 수 없는 이유'}`);
        }
      }
    );
  };

  return (
    <div style={{ padding: '2rem' }}>
      <h2>📱 다날 본인인증 테스트 페이지</h2>
      <button onClick={handleCertify}>본인인증 시작</button>

      {name && (
        <div style={{ marginTop: '1.5rem' }}>
          <p>✅ 이름: {name}</p>
          {phone && <p>📞 전화번호: {phone}</p>}
        </div>
      )}
    </div>
  );
};

export default DanalTestPage;
